<template>
  <div class="home">
    <!-- <div class="grid-container nopadding">
      <div class="grid-x">
        <div class="cell small-12 large-12 relative">
          Home
        </div>
      </div>
    </div> -->
    <div class="menu grid-x align-justify hide-for-small-only">
      <div class="cell shrink">
        <div class="grid-x grid-margin-x">
          <div class="cell auto shrink">
            <img src="@/assets/200622_Ergo_Munich_Logo.svg" @click="$store.trackingClick('MN_ErgoLogo');" />
          </div>
          <div class="cell auto shrink">
            <a href="javascript:void()" @click="goto('akquiseapp');$store.trackingClick('MN_DieAkquise-App');"><span class="menu-link">Die Akquise-App</span></a>
          </div>
          <div class="cell auto shrink">
            <a href="javascript:void()" @click="goto('neuesbu');$store.trackingClick('MN_DieNeueErgoBU');"><span class="menu-link">Die neue ERGO BU</span></a>
          </div>
          <div v-if="$store.compShowByDate && !state.app.isVertrieb" class="cell auto shrink">
            <a href="javascript:void()" @click="goto('weiterbildung');$store.trackingClick('MN_Weiterbildung');"><span class="menu-link">Weiterbildung</span></a>
          </div>
          <div v-if="$store.compShowByDate" class="cell auto shrink">
            <a href="javascript:void()" @click="goto('downloads');$store.trackingClick('MN_Downloads');"><span class="menu-link">Downloads</span></a>
          </div>
        </div>
      </div>
      <div class="cell auto">
        <div class="grid-x grid-margin-x align-right">
          <div class="cell auto text-right">
            <a href="javascript:void()" style="display: inline-block" @click="goto('maklerbetreuung');$store.trackingClick('MN_Maklerbetreuung');"><span class="special">Maklerbetreuung</span></a>
          </div>
          <div class="cell auto shrink text-right" v-if="$store.compIsLoggedIn">
            <a href="javascript:void()" @click="$store.handleLogout()"><span class="menu-link">Logout</span></a>
          </div>
          <div class="cell auto shrink text-right relative" v-else>
            <a href="javascript:void()" @click="ui.showLoginComponent = !ui.showLoginComponent;$store.trackingClick('MN_Login');"><span class="menu-link">Login</span></a>
            <transition name="scale">
              <div class="login-link-wrapper" v-if="ui.showLoginComponent">
                <login-link :open="true" @close="ui.showLoginComponent = false" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>

    <div class="show-for-small-only mobile-header pl-10 pr-10">
      <span class="mob-menu-icon" @click="ui.showMobMenu = !ui.showMobMenu">&#9776;</span>
      <img style="" class="mob-menu-logo" src="@/assets/logo.png" />
    </div>
    <div class="show-for-small-only top-spacer">
      &nbsp;
    </div>
    <transition name="menu">
      <div class="show-for-small-only mob-menu" v-if="ui.showMobMenu">
        <ul class="mob-menu-list mt-30">
          <li><a href="javascript:void()" @click="goto('akquiseapp');ui.showMobMenu=false"><i class="fi-list"></i> <span>Die Akquise-App</span></a></li>
          <li><a href="javascript:void()" @click="goto('neuesbu');ui.showMobMenu=false"><i class="fi-list"></i> <span>Die neue ERGO BU</span></a></li>
          <li v-if="$store.compShowByDate && !state.app.isVertrieb"><a href="javascript:void()" @click="goto('weiterbildung');ui.showMobMenu=false"><i class="fi-list"></i> <span>Weiterbildung</span></a></li>
          <li v-if="$store.compShowByDate"><a href="javascript:void()" @click="goto('downloads');ui.showMobMenu=false"><i class="fi-list"></i> <span>Downloads</span></a></li>
          <li><a href="javascript:void()" @click="goto('maklerbetreuung');ui.showMobMenu=false"><i class="fi-list"></i> <span class="special">Maklerbetreuung</span></a></li>
          <li v-if="$store.compIsLoggedIn"><a href="javascript:void()" @click="$store.handleLogout();ui.showMobMenu=false"><i class="fi-list"></i> <span>Logout</span></a></li>
          <li v-else><a href="javascript:void()" @click="goto('loginlink', {offset: -200});ui.showMobMenu=false"><i class="fi-list"></i> <span>Login</span></a></li>
        </ul>
      </div>
    </transition>
    <transition name="overlay">
      <div class="mob-overlay" v-if="ui.showMobMenu" @click="ui.showMobMenu=false">
      </div>
    </transition>
    
    <router-view />


    <ul class="footer medium-horizontal menu">
      <li><router-link to="contact"><span>Kontakt</span></router-link></li>
      <li><router-link to="impress"><span>Impressum</span></router-link></li>
      <li><router-link to="partnerbedingungen"><span>Partnerbedingungen</span></router-link></li>
      <li><router-link to="datenschutz"><span>Datenschutz</span></router-link></li>
    </ul>
  </div>
</template>

<script>
import Hero from './Hero.vue'
import AppTeaser from './AppTeaser.vue'
import SbuTeaser from './SbuTeaser.vue'
import Weiterbildung from './Weiterbildung.vue'
import Downlaods from './Downloads.vue'
import Contact from './Contact.vue'
import loginLink from '@/components/loginLink.vue'

export default {
  name: 'Home',
  components: {
    Hero,
    AppTeaser,
    SbuTeaser,
    Weiterbildung,
    Downlaods,
    Contact,
    loginLink
  },
  data() {
    return {
      state: this.$store.state,
      ui: {
        showMobMenu: false,
        showLoginComponent: false,
      }
    }
  },
  mounted() {

  },
  methods: {
    goto(scrollto, scrollToOptions) {
      console.log(this.$route)
      if (this.$route.name == 'HomeView') {
        this.$scrollTo('#' + scrollto, scrollToOptions)
      } else {
        this.$router.push({name: 'HomeView', query: { goto: scrollto}})
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@media only screen and (max-width: 700px) {
  
}
.login-link-wrapper {
  background-color:white
  padding:25px
  width:auto
  border-radius:10px
  position:absolute
  right:0
  width:350px
  top:63px
}
.inline {
  display:inline-block
}
.relative {
  position:relative
}
$header-height = 50px
.mobile-header {
  height $header-height
  position: fixed
  width:100%
  box-shadow:0 0 10px 1px rgba(0,0,0,0.4)
  z-index: 100
  background-color white
  .mob-menu-icon {
    font-size: 35px
    &:focus {
      outline: none;
    }
    outline: none;
  }
  .mob-menu-logo {
    height:50%
    position: absolute
    top: 50%
    transform: translateY(-50%)
    right:10px
  }
}
.mob-menu {
  position:fixed
  top: $header-height
  height:100%
  width:80%
  background-color white
  z-index:99
  .mob-menu-list {
    list-style none
    li {
      padding: 15px 0px
      span {
        color: #4a4848
        font-size:20px
        font-weight:lighter
      }
    }
  }
}
.mob-overlay {
  position:fixed
  width:100%
  height:100%
  z-index:98
  background-color: rgba(0,0,0,0.6)
}
.top-spacer {
  height:$header-height
}
.home {
  max-width:1280px
  margin: 0 auto
  background-color: white
}

.menu {
  height 5.3em
  background-color #fff
  padding 1.5em 1.8em 1.5em
  box-shadow 0 .25em .4em 0 rgba(0,0,0,.2)

  a {
    padding-left:0px
    padding-right:0px
  }

  .menu-link {
    font-size 1em
  }

  .special {
    font-size 1.1em
    font-weight bold
    color #ffffff
    background-color #333
    padding .8em 2.2em
    border-radius 1.5em
    box-shadow 0 .35em 1.4em 0 rgba(0,0,0,.5)
  }

  img {
    width auto
    max-width 8em
    height 3em
  }

  li {
    a {
      span {
        font-size 1em
        color #000

        &.special {
          font-size 1.1em
          font-weight bold
          color #ffffff
          background-color #333
          padding .8em 2.2em
          border-radius 1.5em
          box-shadow 0 .35em 1.4em 0 rgba(0,0,0,.5)
        }
      }
    }
  }

}

.footer {
  background-color #71022E
  display flex
  justify-content center
  align-items center
  height 6.85em

  li {
    a {
      padding 0 .7em
      border-right 1px solid #fff
      //white-space nowrap
      &.no-border {
        border none
      }

      span {
        font-size 1.14em
        color #fff
      }
    }
  }
}

.menu-enter-active, .menu-leave-active {
  transition: all .4s ease;
}
.menu-enter, .menu-leave-to {
  transform: translateX(-100%);
}
.overlay-enter-active, .overlay-leave-active {
  transition: all .4s ease;
}
.overlay-enter, .overlay-leave-to {
  opacity:0
}

</style>